import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  justify-content: center;
  padding: 16px;
  flex-wrap: wrap;

  >section {
    display: flex;
    gap: 32px;
  }

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    gap: 16px;
    padding: 0;
  }

  >header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    >div {
      display: flex;
      flex-direction: column;
      align-items: start;

      ${props => props.theme.mediaQuerie.maxWidth.sm}{
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 100%;
        gap: 16px;
      }
    }
  }
  @media screen and (max-width: 780px) {

    display: block;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  @media screen and (max-width: 780px) {
    margin: 24px 0
}
`;

export const CardContainer = styled.div<{ selected: boolean }>`
  display: flex;
  background-color: ${props => props.theme.colors.inputBackground};
  border-radius: 8px;
  gap: 32px;
  padding: 32px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  width: 281px;
  height: 309px;  

  >div {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  
  transition: all 0.5s;

  box-shadow: ${props => props.selected ? '0px 10px 15px 0px rgba(0, 0, 0, 0.25)' : 'none'};
  border: ${props => props.selected ? `2px solid ${props.theme.colors.primary}` : `2px solid ${props.theme.colors.transparent}`};

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    display: ${props => props.selected ? 'flex' : 'none'};
    box-shadow: none;
    border: none;
    cursor: default;
    width: 100%;
    text-align: center;
  }
  
  @media screen and (max-width: 360px) {
    padding: 16px;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  border-radius: 8px;
  padding: 16px;
  background: ${props => props.theme.colors.inputBackground};
  gap: 0;
`;